import { useGetUserNameWithFallback } from '@pba/react-utils';
import type { components } from '@pba/types-openapi-client';
import { Avatar, Link, Text } from 'ui';

type P = {
  member: components['schemas']['UserList'];
};

/**
 * @deprecated Use direct member row implementation instead
 */
const CommunityMemberRow = ({ member }: P) => {
  const getUserNameWithFallback = useGetUserNameWithFallback();
  const fullName = getUserNameWithFallback({ firstName: member.first_name, lastName: member.last_name });

  return (
    <div className="community-member-row">
      <div className="community-member-row__avatar">
        <Link style={{ textDecoration: 'inherit' }} to={`/members/${member.id}`}>
          <Avatar size="lg" src={member.profile_photo}>
            {fullName}
          </Avatar>
        </Link>
      </div>
      <div style={{ display: 'table-cell', verticalAlign: 'middle' }}>
        <Link style={{ textDecoration: 'inherit' }} to={`/members/${member.id}`}>
          <Text>{fullName}</Text>
        </Link>
      </div>
    </div>
  );
};

export default CommunityMemberRow;
